import { FC, useEffect } from 'react';

import RichText from '@eneco/components/RichText/RichText';

import { Layout } from '../components';
import { useStepContent } from '../hooks';
import type { FlowNavigationContent } from '../stepsSharedComponents/Navigation/navigation-content.types';

export const FlowRedirect: FC = () => {
  const textualData = useStepContent<FlowNavigationContent>('Navigation');

  useEffect(() => {
    window?.scrollTo({
      top: 0,
    });
  }, []);

  return (
    <Layout>
      <Layout.Content variant="B" withDelayedAnimation={true}>
        <RichText html={textualData?.redirectMessageContent} />
      </Layout.Content>
    </Layout>
  );
};
